import { valtioDevTools } from '@lib/utils/devTools';
import { proxy } from 'valtio';
import { AudioDevice, DeviceFailureResult, ErrorCategory } from './types';

export type AudioDevicesState = {
  /** List of available audio input (microphone) devices */
  audioInputDevices: AudioDevice[];
  /** List of available audio output (speaker) devices */
  audioOutputDevices: AudioDevice[];
  /** Device ID of the currently active audio input device, undefined when not initialized */
  currentInputDeviceId: string | undefined;
  /** Device ID of the currently active audio output device, undefined when not initialized */
  currentOutputDeviceId: string | undefined;
  /** Device ID of the currently active ring output device, undefined when not initialized */
  currentRingDeviceId: string | undefined;
  /** Web Audio API reference for visualization */
  microphoneAnalyser: AnalyserNode | null;
  /** Whether devices have been enumerated and are ready for use */
  isDevicesReady: boolean;
  /** Error category if a device operation failed, null otherwise */
  errorCategory: ErrorCategory | null;
  /** Whether the microphone test is currently active */
  isTestingMicrophone: boolean;
  /** Whether the speaker test is currently active */
  isTestingSpeaker: boolean;
  /** Last device switch failure details, null when no error */
  lastSetDevicesError: {
    audioInput: DeviceFailureResult;
    audioOutput: DeviceFailureResult;
    ringOutput: DeviceFailureResult;
  } | null;
};

export const audioDevicesState = proxy<AudioDevicesState>({
  audioInputDevices: [],
  audioOutputDevices: [],
  currentInputDeviceId: undefined,
  currentOutputDeviceId: undefined,
  currentRingDeviceId: undefined,
  microphoneAnalyser: null as AnalyserNode | null,
  isDevicesReady: false,
  errorCategory: null,
  isTestingMicrophone: false,
  isTestingSpeaker: false,
  lastSetDevicesError: null,
});

valtioDevTools(audioDevicesState, 'audioDevicesState');
